import React from "react";
import { Outlet } from "react-router-dom";
import SupportSidebar from "./SupportSidebar";
import AdminHeader from "../../components/AdminDashboard/Header";


export default function SupportLayout() {
  return (
    <div className="dashboard_wrapper">

      {/* SIDEBAR */}
      <SupportSidebar />

      {/* MAIN BODY */}
      <div className="dashboard_body">

        {/* HEADER */}
        <AdminHeader />

        {/* CONTENT */}
        <div className="dashboard_content">
          <Outlet />
        </div>

      </div>

    </div>
  );
}